import {memo} from 'react';

export const DollarIcon = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 1.333v13.334M11.333 3.667H6.5a2.167 2.167 0 000 4.333h3a2.167 2.167 0 010 4.333H4.667"
    />
  </svg>
));

DollarIcon.displayName = 'DollarIcon';
